// extracted by mini-css-extract-plugin
module.exports = {"main-component":"emptyHistory_main-component__2FF6E"};